import Vue from "vue"

import {
  Button,
  Field,
  Form,
  Stepper,
  Tag,
  Divider,
  Picker,
  Popup,
  Notify,
  Checkbox,
  Dialog,
  Icon,
  Col,
  Row,
  Swipe,
  SwipeItem,
  Popover,
  Overlay,
  Cell,
  NoticeBar,
  Grid,
  GridItem,
  NavBar,
  Tab,
  Tabs,
  Search,
  Calendar,
  List,
  DatetimePicker,
  Uploader,
  SwitchCell
} from "vant"
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Button)
Vue.use(Field)
Vue.use(Form)
Vue.use(Stepper)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Notify)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Col)
Vue.use(Row)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Popover)
Vue.use(Overlay)
Vue.use(Cell)
Vue.use(NoticeBar)
Vue.use(NavBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Calendar)
Vue.use(List)
Vue.use(DatetimePicker)
Vue.use(Uploader)
Vue.use(SwitchCell)
Vue.prototype.document = document
